import { Alert, Box, Button, DatePicker, Grid } from '@welbe/design-system';
import { PageWrapper, tokens } from '@welbe/web-design-system';
import { ReactComponent as Nom024 } from 'App/assets/img/nom024.svg';
import { handleToast } from 'helpers/handleToast';
import { useRef, useState } from 'react';
import { postGenerateReport } from './ReportNom024.services';

export const ReportNom024 = () => {
	const [isLoading, setLoading] = useState<boolean>(false);
	const selectedMonthRef = useRef<string>('');
	const [hasSelectedMonth, setHasSelectedMonth] = useState<boolean>(false);
	// We set the minimum month to this date because is the month that we implemented the feature
	const minMonth = '2026-04-01';

	const now = new Date();
	const maxMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
		2,
		'0',
	)}-01`;

	const handleClickGenerateReport = async () => {
		const selectedMonth = selectedMonthRef.current;

		if (!selectedMonth) return null;

		const minMonthComparable = minMonth.slice(0, 7);
		const maxMonthComparable = maxMonth.slice(0, 7);

		if (
			selectedMonth < minMonthComparable ||
			selectedMonth > maxMonthComparable
		) {
			handleToast('error', 'Fecha inválida', 'Selecciona un mes válido');
			return null;
		}

		const [year, month] = selectedMonth.split('-');

		const firstDay = `${year}-${month}-01`;
		const lastDay = new Date(Number(year), Number(month), 0)
			.toISOString()
			.slice(0, 10);

		try {
			setLoading(true);
			await postGenerateReport(firstDay, lastDay);
			handleToast(
				'success',
				'Estamos generando tu reporte',
				'En cuanto esté listo lo recibirás por correo electrónico',
			);
		} catch {
			handleToast(
				'error',
				'Error al generar el reporte',
				'Hubo un error al generar el reporte',
			);
		} finally {
			setLoading(false);
		}
	};

	return (
		<PageWrapper
			icon={
				<Box css={{ '& path': { fill: tokens.color_gray_dark } }}>
					<Nom024 />
				</Box>
			}
			title="Reporte NOM-024"
		>
			<Box bg="white" p="20px">
				<Alert.Root variant="surface">
					<Alert.Indicator />
					<Alert.Description>
						Selecciona un mes y un año para generar el reporte. El reporte será
						enviado a tu correo electrónico registrado.
					</Alert.Description>
				</Alert.Root>

				<Grid
					pt={4}
					gap={4}
					alignItems="flex-end"
					gridTemplateColumns="250px auto"
				>
					<DatePicker.Snippet
						label="Mes"
						name="month"
						required
						disabled={isLoading}
						view="month"
						min={minMonth}
						max={maxMonth}
						onChange={(value) => {
							selectedMonthRef.current = value;
							setHasSelectedMonth(!!value);
						}}
					/>

					<Button
						onClick={handleClickGenerateReport}
						disabled={!hasSelectedMonth}
						loading={isLoading}
						width="fit-content"
					>
						Generar reporte
					</Button>
				</Grid>
			</Box>
		</PageWrapper>
	);
};
